import axiosInstance from "../config/axios.config";
import { getCookie } from "../helpers/localStorage";

export const getTherapiesApi = (params) =>
  axiosInstance.get("/careservices/therapies/list/", {
    params: {
      limit: 50,   
      ...params
    }
  });


export const createTherapyApi = (data) =>
  axiosInstance.post("/careservices/therapies/", data);

export const updateTherapyApi = (id, data) =>
  axiosInstance.patch(`/careservices/therapies/${id}/`, data);

export const deleteTherapyApi = (id) =>
  axiosInstance.delete(`/careservices/therapies/${id}/`);

export const uploadTherapiesApi = (payload) =>
  axiosInstance.post(`/careservices/therapies/bulk-upload/`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getCookie("access_token")}`,
      Organization: `${getCookie("organisation_id")}`,
    },
  });
